// LoginModal.js
import React from 'react';

import { useTranslation } from 'react-i18next'; // ✅ เพิ่ม
const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    background: '#fff',
    padding: '30px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '300px',
  },
  button: {
    marginTop: '20px',
    marginRight: '10px',  // เพิ่มช่องว่างทางขวา
    padding: '10px 20px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  
  }
};

const LoginModal = ({ onClose }) => {
  const redirectToLogin = () => {
    window.location.href = '/loginForm'; // หรือใช้ useNavigate จาก react-router-dom ถ้ามี routing
  };
 const { t } = useTranslation(); // ✅ ใช้ t แปลภาษา
  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
    <h3>{t('You are not logged in')}</h3>
      <p>{t('Please log in to use this feature')}</p>
      <button style={modalStyles.button} onClick={redirectToLogin}>{t('Go to Login')}</button>
      <button style={{ ...modalStyles.button, backgroundColor: '#888' }} onClick={onClose}>{t('Cancel')}</button>
     </div>
    </div>
  );
};

export default LoginModal;
